

export const sidebarStructure = [
    {
        id: "1", 
        name: "trips",
        parent: true,
        icon: "airplane",
      },

    {
      id: "2",
      name: "invites",
      parent: true,
      icon: "profiles",
      child: [
        {
          id: "facebook",
          title: `Facebook`,
          name: "facebook",
          link: "/invite-friend/facebook",
          icon: "facebook"
        },
        {
            id: "whatsapp",
            title: `WhatsApp`,
            name: "whatsapp",
            link: "/invite-friend/whatsapp",
            icon: "whatsapp"
        },
        {
          id: "email",
          title: `Email`,
          name: "email",
          link: "/invite-friend/email",
          icon: "email"
        }
      ]
    },

    {
      id: "",
      name: "",
      parent: true,
      icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },
  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },

  {
    id: "",
    name: "",
    parent: true,
    icon: "",
  },


    {
      id: "3",
      name: "settings",
      parent: true,
      icon: "settings",
    },
    {
      id: "4",
      name: "logout",
      parent: true,
      icon: "logout",
      link: "/logout"
    }
  ];
  
 
  